import { Customer_Provider } from '@proto/api/customers/resources';

export class ProviderTypes {
  static providerTypeDisplay(type: Customer_Provider | undefined): string {
    if (!type) {
      return '';
    }
    switch (type) {
      case Customer_Provider.PROVIDER_FACEBOOK: {
        return $localize`Facebook帳號`;
      }
      case Customer_Provider.PROVIDER_PHONE: {
        return $localize`手機帳號`;
      }
      default: {
        return $localize`E-Mail帳號`;
      }
    }
  }
}
